import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManagePipelinesPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminManagePipelinesPage',
  setup(__props) {

    document.title = "Manage pipelines"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useAllPipelinesQuery } = useAdminManagePipelinesPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { model, run } = useAllPipelinesQuery(tid)
    const pipelines = computed(() => model.value?.Pipelines || [])
    run()

    onMounted(() => {
        runCurrentUserQueryV1()
    })

return { __sfc: true,tid, useCurrentUserQuery, useAllPipelinesQuery, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, model, run, pipelines }
}

})